import { useState } from 'react';

import config from '@/config';
import useTranslations from '@/i18n/useTranslations';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import { FormDropdown } from '@/shared-components/dropdown';
import FormError from '@/shared-components/error/components/FormError';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';
import { getArtworkTaxonomyOptions } from '@/utils/artworkTaxonomy';

import './styles/ArtworkMediaInput.css';

function CustomMediumPopup({ close, onCreate, customMedium }) {
  const [newMedium, setNewMedium] = useState("");

  return (
    <>
      <div className="custom-medium-popup__header">
        <Text className="custom-medium-popup__header-text">
          {customMedium}
        </Text>

        <XIcon className="custom-medium-popup__close" onClick={close}/>
      </div>
      <Text
        className="text-custom__component custom-medium-text"
        paragraph>
        Specify the mediums used to create the artwork
      </Text>
      <input 
        type="text" 
        className="custom-medium-popup__input" 
        spellCheck={false} 
        autoComplete='off' 
        value={newMedium} 
        onInput={e => setNewMedium(e.target.value)}
        placeholder='Enter the mediums...'
      />
      <ContinueButton 
        className={newMedium === "" ? "" : "custom-medium-popup__save"}
        turnOff={newMedium === ""}
        onClick={()=>onCreate(newMedium)}
      >
        Save
      </ContinueButton>
    </>
  );
}

export default function ArtworkMediaInput({
  value,
  element,
  error,
  previewMode,
  onChange,
  infoIcon,
  margin = false,
  disabled = false,
  className = '',        // <— capturamos tu className="can-edit"
}) {
  const t = useTranslations('common.forms.add_artwork');
  const [customMedium, setCustomMedium] = useState(null);

  function selectMedium(medium) {
    if(medium === "Mixed Media") {
      setCustomMedium("Mixed Media");
    } else if(medium === "Other") {
      setCustomMedium("Other");
    }  else {
      onChange(medium);
    }
  }

  function onCreateCustomMedium(medium) {
    const newMedium = customMedium + ': ' + medium;
    onChange(newMedium);
    setCustomMedium(null);
  }

  return (
    <>
      <div
        className={[
          'artwork-media-input__outter-container',
          margin && 'margin',
          className,                   // <— aquí lo metemos
        ].filter(Boolean).join(' ')}
      >
        <FormDropdown
          className={`artwork-media-input__container${disabled ? ' is-disabled' : ''}`}
          element={element}
          label="Medium / Material(s)"
          value={value}
          options={getArtworkTaxonomyOptions(config.forms.medium_options, 'mediums', t)}
          readOnly={disabled}
          previewMode={previewMode}
          infoIcon={infoIcon}
          optionsHeader={t('dropdown.medium_header')}
          onOptionSelect={selectMedium}
        />

        <FormError 
          error={error} 
          alternativeElement={`${element}_error`} 
          errorClassName="input-error" 
          element={element}
        />
      </div>
      <GenericPopup 
        className="custom-medium-popup" 
        open={customMedium !== null} 
        opacity
      >
        <CustomMediumPopup 
          close={()=>setCustomMedium(null)} 
          onCreate={onCreateCustomMedium} 
          customMedium={customMedium}
        />
      </GenericPopup>
    </>
  );
}
